import React, { useState, useEffect, useMemo, memo } from 'react';
import { useSelector } from 'react-redux';
import {
  Icon,
  ListItem,
  ListItemIcon,
  Typography,
  Link,
  Box,
  Tooltip,
} from '@material-ui/core';
import { Link as RouterLink } from 'react-router-dom';

import useStyles from './styles';

const MenuItem = props => {
  const {
    path,
    withSubPages,
    title,
    icon,
    target,
    className,
    locked,
    lockedMessage,
    ...otherProps
  } = props;
  const classes = useStyles();
  const {
    router: {
      location: { pathname: routerPath },
    },
  } = useSelector(state => state);
  const [selected, setSelected] = useState(false);

  useEffect(() => {
    setSelected(
      withSubPages ? routerPath.startsWith(path) : path === routerPath,
    );
  }, [withSubPages, routerPath, path]);

  const navigationLink = useMemo(() => {
    if (locked) {
      return {
        component: Box,
      };
    }
    if (path) {
      return {
        to: path,
        component: RouterLink,
      };
    }
    return {};
  }, [path, locked]);

  return (
    <ListItem
      className={classes.container}
      classes={{ selected: classes.listItemSelected }}
      selected={selected}
    >
      <Link
        className={`list-channels-item-link ${className}`}
        underline="none"
        target={target}
        {...navigationLink}
        {...otherProps}
      >
        <ListItemIcon className="list-channels-item-icon">
          <Icon>{icon}</Icon>
        </ListItemIcon>
        <Typography className="list-channels-item-text" variant="body2">
          {title}
        </Typography>
        {locked && lockedMessage && (
          <Tooltip
            className="list-channels-item-icon-after"
            title={lockedMessage}
            placement="left"
          >
            <Icon fontSize="small">lock</Icon>
          </Tooltip>
        )}
        {target === '_blank' && (
          <Icon className="list-channels-item-icon-after" fontSize="small">
            launch
          </Icon>
        )}
      </Link>
    </ListItem>
  );
};

export default memo(MenuItem);
